// @ts-expect-error highcharts@7 is not typed

import { TEXT_COLOR, TEXT_INACTIVE, TOOLTIP_BACKGROUND_COLOR, ColorSeries } from './colors';
import { xAxis, yAxis } from './axisOptions';
export const chartOptions = {
  chart: {
    animation: false,
    reflow: false,
    // avoid extra work since reflow will be handled by our component using ResizeObserver
    style: {
      fontFamily: 'inherit'
    }
  },
  colors: ColorSeries.DEFAULT,
  title: {
    text: ''
  },
  plotOptions: {
    series: {
      animation: false,
      dataLabels: {
        color: TEXT_COLOR,
        style: {
          fontWeight: '600'
        }
      }
    }
  },
  xAxis,
  yAxis,
  legend: {
    enabled: true,
    borderWidth: 0,
    symbolRadius: 4,
    symbolWidth: 8,
    symbolHeight: 8,
    itemMarginBottom: 4,
    align: 'left',
    verticalAlign: 'top',
    maxHeight: 40,
    y: -8,
    margin: 20,
    itemStyle: {
      color: TEXT_COLOR,
      fontSize: '12px',
      fontWeight: '600',
      textDecoration: 'none'
    },
    navigation: {
      activeColor: TEXT_COLOR,
      inactiveColor: TEXT_INACTIVE,
      style: {
        color: TEXT_COLOR,
        fontSize: '12px'
      }
    }
  },
  tooltip: {
    backgroundColor: TOOLTIP_BACKGROUND_COLOR
  },
  credits: {
    enabled: false
  }
};